<div class="row mb-3">
    <label class="col-2 col-form-label" translate="CONFIRMATION_COMMENTS_FOR_CUSTOMER_COMMENTS"></label>
    <div class="col-8">
        <pace-core-text-input
            [(model)]="model.commentsForCustomerText"
            [parentForm]="parentForm"
        ></pace-core-text-input>
    </div>
</div>
